import sportclubApi from "../../../api/sportclubApi";
import redirector from "../../../util/redirector";

export default class GemeenteLinkOrganisatiePageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const context = this.context;
        context.props.loadOverzichtLayout("Sportclub melden");
    }

    cancel() {
        redirector.goTo("/gemeente/overzicht");
    }

    change(event) {
        const property = event.target.name;
        const value = event.target.value;
        const context = this.context;
        const searchModel = context.state.searchModel;

        searchModel[property] = value;

        context.setState({
            searchModel: searchModel,
            nameFilterHasFocus: false
        });
    }

    search() {
        const context = this.context;
        const searchModel = context.state.searchModel;
        const ajaxActions = context.props.ajaxActions;
        const gemeenteId = context.props.gemeenteId;

        ajaxActions.started();

        sportclubApi.searchSportclubsGemeente(gemeenteId, searchModel)
            .then((response) => {
                ajaxActions.ended();
                this.handleSearchResult(response);
            })
            .catch((ex) => {
                ajaxActions.failed();
            });
    }

    handleSearchResult(response) {
        const context = this.context;
        const item = response.data.item;

        context.setState({
            sportclubs: item.sportclubs ? item.sportclubs : [],
            totalSearchResult: response.data.hasValidationErrors ? -1 : item.totalSearchResult,
            searchModel: {
                naam: item.naam,
                afkorting: item.afkorting,
                ondernemingsnummer: item.ondernemingsnummer,
                telefoon: item.telefoon,
                email: item.email,
                website: item.website
            },
            validationMessageType: response.data.validationMessageType,
            errors: response.data.validationResults
        });
    }

    addSportclub(id) {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        const gemeenteId = context.props.gemeenteId;

        ajaxActions.started();

        sportclubApi.requestLinkSportclubGemeente(id, gemeenteId)
            .then((response) => {
                ajaxActions.ended();

                context.props.setActiveSportclub(id, response.data.transactionId, response.data.readOnly);
                redirector.goTo(`/sportorganisatie/organisatie/` + response.data.transactionId);
            })
            .catch((ex) => {
                ajaxActions.failed();
            });

        context.setState({
            modalIsOpen: false
        });
    }

    openModal(sportclub) {
        const context = this.context;
        context.setState({
            modalIsOpen: true,
            modalSportclub: sportclub
        });
    }

    closeModal() {
        const context = this.context;
        context.setState({
            modalIsOpen: false
        });
    }

    createNew() {
        const context = this.context;
        context.props.setSearchModel(context.state.searchModel);
        context.props.setActiveSportclub(null, null, false, true);
        redirector.goTo(`/sportorganisatie/organisatie/` + null);
    }
}